<form [formGroup]="form">
  <div nz-row [nzGutter]="[10,10]">
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 6}">
      <beautyapp-input
        label="ანკეტის #"
        formControlName="cardNo"
        (ngModelChange)="checkUser()"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 6}">
      <beautyapp-input label="სახელი" formControlName="firstname" [required]="true"></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 6}">
      <beautyapp-input label="გვარი" formControlName="lastname"></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 6}">
      <beautyapp-input
        label="მობილურის ნომერი"
        formControlName="mobilePhone"
        [required]="true"
        (ngModelChange)="checkUser()"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 16}">
      <beautyapp-select
        label="{{'users.form.userSource' | translate}}"
        [data]="userSources()"
        displayMember="name"
        valueMember="id"
        formControlName="userSourceId"
        size="large"
      >
      </beautyapp-select>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 6}">
      <beautyapp-input
        label="პირადი ნომერი"
        formControlName="identityNumber"
        [required]="personalIdRequired"
        [errors]="{ pattern: personalIdError }"
      ></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-select
        label="USER.gender"
        [data]="genders"
        displayMember="value"
        valueMember="id"
        formControlName="gender"
      >
      </beautyapp-select>
    </div>

    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-datepicker
        formControlName="birthDate"
        [label]="'USER.birthDate'"
      ></beautyapp-datepicker>
    </div>
    <div nz-col class="gutter-row" [nzSpan]="8">
      <beautyapp-select
        label="{{'სისხლის ჯგუფი' | translate}}"
        [data]="bloodGroups"
        displayMember="alias"
        valueMember="value"
        formControlName="bloodGroup"
        size="large"
      >
      </beautyapp-select>
    </div>

    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 8}">
      <beautyapp-input label="ქალაქი" formControlName="city"></beautyapp-input>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 16}">
      <beautyapp-input label="მისამართი" formControlName="address"></beautyapp-input>
    </div>

    <div nz-col [nzXs]="{ span: 24}" [nzLg]="{ span: 24}">
      <beautyapp-input label="სამუშაო ადგილი" formControlName="workplace"></beautyapp-input>
    </div>
    <div nz-col  [nzSpan]="24">
      <beautyapp-textarea
        size="large"
        formControlName="description"
        [label]="'users.form.additionalInformation' | translate"
        placeholder="{{'users.form.additionalInformation' | translate}}"
      ></beautyapp-textarea>
    </div>

  </div>
</form>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modal.close()">დახურვა</button>
  <button nz-button nzType="primary" (click)="submit()">შენახვა</button>
</div>
